
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@invent/datagrid-common", version: "1.59.0", factory: () => (() => (__webpack_require__(44189))), eager: 1 }, { name: "@invent/http-client", version: "2.1.0", factory: () => (() => (__webpack_require__(56612))), eager: 1 }, { name: "@invent/json-settings", version: "1.24.7", factory: () => (() => (__webpack_require__(53869))), eager: 1 }, { name: "@invent/mocks", version: "0.2.1", factory: () => (() => (__webpack_require__(93813))), eager: 1 }, { name: "@invent/platform-api", version: "1.25.0", factory: () => (() => (__webpack_require__(46589))), eager: 1 }, { name: "@invent/tailwind-integration/react", version: "1.22.3", factory: () => (() => (__webpack_require__(61957))), eager: 1 }, { name: "@invent/wl-ui-kit-next", version: "1.12.2", factory: () => (() => (__webpack_require__(51898))), eager: 1 }, { name: "@invent/wl-ui-kit", version: "3.225.2", factory: () => (() => (__webpack_require__(67133))), eager: 1 }, { name: "@invent/wlabel-shared-components", version: "1.25.3", factory: () => (() => (__webpack_require__(27191))), eager: 1 }, { name: "@tanstack/react-query", version: "4.44.0", factory: () => (() => (__webpack_require__(385))), eager: 1 }, { name: "date-fns", version: "2.30.0", factory: () => (() => (__webpack_require__(6948))), eager: 1 }, { name: "date-fns", version: "4.4.0", factory: () => (() => (__webpack_require__(98123))), eager: 1 }, { name: "date-fns", version: "4.4.0", factory: () => (() => (__webpack_require__(80805))), eager: 1 }, { name: "effector-react", version: "22.5.4", factory: () => (() => (__webpack_require__(81809))), eager: 1 }, { name: "effector", version: "22.8.8", factory: () => (() => (__webpack_require__(4865))), eager: 1 }, { name: "flagged", version: "3.0.0", factory: () => (() => (__webpack_require__(51785))), eager: 1 }, { name: "ramda", version: "^0.28.0", factory: () => (() => (__webpack_require__(59756))), eager: 1 }, { name: "react-dnd-html5-backend", version: "14.1.0", factory: () => (() => (__webpack_require__(34696))), eager: 1 }, { name: "react-dnd", version: "14.0.5", factory: () => (() => (__webpack_require__(7272))), eager: 1 }, { name: "react-dom", version: "18.3.1", factory: () => (() => (__webpack_require__(40961))), eager: 1 }, { name: "react-query", version: "3.39.3", factory: () => (() => (__webpack_require__(2582))), eager: 1 }, { name: "react-router-dom", version: "5.3.4", factory: () => (() => (__webpack_require__(54625))), eager: 1 }, { name: "react-router", version: "5.3.4", factory: () => (() => (__webpack_require__(56347))), eager: 1 }, { name: "react-use", version: "17.6.1", factory: () => (() => (__webpack_require__(41662))), eager: 1 }, { name: "react", version: "18.3.1", factory: () => (() => (__webpack_require__(96540))), eager: 1 }, { name: "styled-components", version: "5.3.11", factory: () => (() => (__webpack_require__(4093))), eager: 1 }] }, uniqueName: "whitelabel" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

